<template>
    <teleport to=".form-container">
        <transition name="fade">
            <div v-if="state.toast.show" class="popup error">
                <p style="color: white; font-weight: bold">{{ state.toast.message }}</p>
            </div>
        </transition>
    </teleport>
</template>

<script>
import { state } from "../store";
export default {
    name: 'Toast',
    setup() {
        return { state }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.popup {
    text-align: center;
    border-radius: 5px;
    width: 200px;
    padding: 0.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.error {
    background-color: crimson;
}
</style>